import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/ui/layouts/account.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/ui/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/ui/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/ui/layouts/empty.vue").then(m => m.default || m))
}